"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ratio = require("promo-js/lib/services/ratio/ratio.service");

var _videoPopup = _interopRequireDefault(require("../common/video-popup/video-popup"));

var _dashboardTabs = _interopRequireDefault(require("./dashboard-tabs/dashboard-tabs"));

var _actionMenuTypes = _interopRequireDefault(require("../common/app-action-menu/action-menu-types"));

var _dashboardVideos = _interopRequireDefault(require("./dashboard-videos.shape"));

var _noPublishedFound = _interopRequireDefault(require("./no-published-found/no-published-found"));

var _noDraftsFound = _interopRequireDefault(require("./no-drafts-found/no-drafts-found"));

var _confirmDeleteVideoPopup = _interopRequireDefault(require("./confirm-delete-video-popup/confirm-delete-video-popup"));

var _confirmDuplicateVideoPopup = _interopRequireDefault(require("./confirm-duplicate-video-popup/confirm-duplicate-video-popup"));

var _videoTypes = _interopRequireDefault(require("./video-types"));

var _dashboardGrid = _interopRequireDefault(require("./dashboard-grid/dashboard-grid"));

var _dashboardTabTypes = _interopRequireDefault(require("./dashboard-tabs/dashboard-tab-types"));

var _dashboardService = _interopRequireDefault(require("./shapes/dashboard-service.shape"));

var _videoService = _interopRequireDefault(require("./shapes/video-service.shape"));

class DashboardPage extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "state", {
      selectedTab: _dashboardTabTypes.default.DRAFTS,
      playedVideo: null,
      showConfirmDeleteVideoPopup: false,
      showConfirmDuplicateVideoPopup: false,
      drafts: this.props.drafts,
      published: this.props.published,
      isPublishing: false
    });
    (0, _defineProperty2.default)(this, "onTabChange", tab => {
      this.setState({
        selectedTab: tab
      });
      const {
        onTabChange
      } = this.props;

      if (onTabChange) {
        onTabChange(tab);
      }
    });
    (0, _defineProperty2.default)(this, "onPlayDraftVideo", async video => {
      // fetch the video json from the server
      const {
        videoService
      } = this.props;
      const videoData = await videoService.fetchVideoData(undefined, video.id);
      video.videoData = videoData.data;
      this.onPlayVideo(video);
    });
    (0, _defineProperty2.default)(this, "onPlayVideo", video => {
      this.setState({
        playedVideo: video
      });
      const {
        selectedTab
      } = this.state;
      const {
        onPlayVideo
      } = this.props;

      if (onPlayVideo) {
        onPlayVideo({
          video,
          tab: selectedTab
        });
      }
    });
    (0, _defineProperty2.default)(this, "onEdit", video => {
      const {
        id
      } = video;
      const {
        onEdit
      } = this.props;
      onEdit(id);
    });
    (0, _defineProperty2.default)(this, "onDelete", video => {
      this.videoToDelete = video;
      this.setState({
        showConfirmDeleteVideoPopup: true
      });
    });
    (0, _defineProperty2.default)(this, "onPublish", video => {
      this.setState({
        isPublishing: true
      }, async () => {
        const {
          videoService,
          onPublish
        } = this.props;
        const videoData = await videoService.fetchVideoData(undefined, video.id);
        const {
          id,
          renderingDuration
        } = await videoService.createVideo(videoData);
        onPublish(id, renderingDuration);
      });
    });
    (0, _defineProperty2.default)(this, "onRepublish", video => {
      const {
        id
      } = video;
      const {
        onPublish
      } = this.props;
      onPublish(id);
    });
    (0, _defineProperty2.default)(this, "closeConfirmDuplicateVideoPopup", () => {
      this.setState({
        showConfirmDuplicateVideoPopup: false
      });
    });
    (0, _defineProperty2.default)(this, "onConfirmDuplicateVideo", async () => {
      const {
        dashboardService
      } = this.props;
      const video = await dashboardService.duplicateVideo(this.videoToDuplicate.id);

      if (video) {
        const {
          drafts
        } = this.state;
        const videos = [...drafts.videos];
        videos.unshift(video);
        drafts.videos = videos;
        this.setState({
          selectedTab: _dashboardTabTypes.default.DRAFTS,
          drafts
        });
      }

      this.closeConfirmDuplicateVideoPopup();
      this.onEdit(video);
    });
    (0, _defineProperty2.default)(this, "onDuplicateVideo", video => {
      this.videoToDuplicate = video;
      this.setState({
        showConfirmDuplicateVideoPopup: true
      });
    });
    (0, _defineProperty2.default)(this, "closeConfirmDeleteVideoPopup", () => {
      this.setState({
        showConfirmDeleteVideoPopup: false
      });
    });
    (0, _defineProperty2.default)(this, "onConfirmVideoDelete", async () => {
      const {
        dashboardService
      } = this.props;
      const success = await dashboardService.deleteVideo(this.videoToDelete.id);

      if (success) {
        const {
          drafts,
          published,
          selectedTab
        } = this.state;
        const tabVideos = selectedTab === _dashboardTabTypes.default.DRAFTS ? drafts : published;
        const videos = [...tabVideos.videos];
        const videoIndex = videos.findIndex(video => video.id === this.videoToDelete.id);
        videos.splice(videoIndex, 1);
        tabVideos.videos = videos;
        this.setState({
          [selectedTab]: tabVideos
        });
        this.closeConfirmDeleteVideoPopup();
      }
    });
    (0, _defineProperty2.default)(this, "onVideoClosed", () => {
      this.setState({
        playedVideo: null
      });
    });
    (0, _defineProperty2.default)(this, "requestNextDrafts", async () => {
      const {
        dashboardService
      } = this.props;
      const {
        selectedTab
      } = this.state;
      const {
        cursor
      } = this.state[selectedTab];
      const newDrafts = await dashboardService.fetchDraftVideos(undefined, {
        page: cursor
      });
      this.addNextVideos(newDrafts);
    });
    (0, _defineProperty2.default)(this, "requestNextPublished", async () => {
      const {
        dashboardService
      } = this.props;
      const {
        selectedTab
      } = this.state;
      const {
        cursor
      } = this.state[selectedTab];
      const newPublished = await dashboardService.fetchPublishVideos(undefined, {
        page: cursor
      });
      this.addNextVideos(newPublished);
    });
  }

  /**
   * Adds new fetched videos to the current selected tab
   */
  addNextVideos(newVideos) {
    const {
      selectedTab
    } = this.state;
    const {
      videos
    } = this.state[selectedTab];
    const {
      cursor,
      hasNextPage
    } = newVideos;
    this.setState({
      [selectedTab]: {
        cursor,
        hasNextPage,
        videos: [...videos, ...newVideos.videos]
      }
    });
  }

  getVideoType() {
    const {
      selectedTab
    } = this.state;
    return selectedTab === _dashboardTabTypes.default.DRAFTS ? _videoTypes.default.DRAFT : _videoTypes.default.VIDEO;
  }
  /**
   * Renders the video popup
   */


  renderVideoPopup() {
    const {
      playedVideo
    } = this.state;
    const {
      videoUrl,
      videoData,
      ratio
    } = playedVideo;
    return /*#__PURE__*/_react.default.createElement(_videoPopup.default, {
      closeButton: true,
      onClose: this.onVideoClosed,
      ratio: _ratio.RATIOS_BY_NAME[ratio].key,
      videoUrl: videoUrl,
      videoData: videoData
    });
  }

  render() {
    const {
      selectedTab,
      playedVideo,
      showConfirmDeleteVideoPopup,
      showConfirmDuplicateVideoPopup,
      drafts,
      published,
      isPublishing
    } = this.state;
    const {
      tabs,
      confirmDeleteVideoPopup,
      onCreate
    } = this.props;
    const Tabs = tabs;
    const ConfirmDeleteVideo = confirmDeleteVideoPopup;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "dashboard-page"
    }, /*#__PURE__*/_react.default.createElement(Tabs, {
      selectedTab: selectedTab,
      onChange: this.onTabChange
    }), /*#__PURE__*/_react.default.createElement(_dashboardGrid.default, {
      className: (0, _classnames.default)({
        'dashboard-grid--visible': selectedTab === _dashboardTabTypes.default.DRAFTS && drafts.videos.length > 0,
        'dashboard-grid--disabled': isPublishing
      }),
      videos: drafts.videos,
      actionFeatures: [_actionMenuTypes.default.EDIT, _actionMenuTypes.default.DUPLICATE, _actionMenuTypes.default.DELETE],
      onPlay: this.onPlayDraftVideo,
      onEdit: this.onEdit,
      onDuplicate: this.onDuplicateVideo,
      onDelete: this.onDelete,
      onPublish: this.onPublish,
      hasPlayButton: false,
      hasMore: drafts.hasNextPage,
      loadMore: this.requestNextDrafts
    }), selectedTab === _dashboardTabTypes.default.DRAFTS && drafts.videos.length === 0 && /*#__PURE__*/_react.default.createElement(_noDraftsFound.default, {
      onCreateNewClick: onCreate
    }), /*#__PURE__*/_react.default.createElement(_dashboardGrid.default, {
      className: (0, _classnames.default)({
        'dashboard-grid--visible': selectedTab === _dashboardTabTypes.default.PUBLISHED && published.videos.length > 0
      }),
      videos: published.videos,
      publishButton: "Republish",
      actionFeatures: [_actionMenuTypes.default.DUPLICATE, _actionMenuTypes.default.DELETE],
      onPlay: this.onPlayVideo,
      onDuplicate: this.onDuplicateVideo,
      onDelete: this.onDelete,
      onPublish: this.onRepublish,
      hasMore: published.hasNextPage,
      loadMore: this.requestNextPublished
    }), selectedTab === _dashboardTabTypes.default.PUBLISHED && published.videos.length === 0 && /*#__PURE__*/_react.default.createElement(_noPublishedFound.default, null), playedVideo && this.renderVideoPopup(), showConfirmDeleteVideoPopup && /*#__PURE__*/_react.default.createElement(ConfirmDeleteVideo, {
      onClose: this.closeConfirmDeleteVideoPopup,
      onConfirm: this.onConfirmVideoDelete,
      videoType: this.getVideoType(),
      videoName: this.videoToDelete.title
    }), showConfirmDuplicateVideoPopup && /*#__PURE__*/_react.default.createElement(_confirmDuplicateVideoPopup.default, {
      onClose: this.closeConfirmDuplicateVideoPopup,
      onConfirm: this.onConfirmDuplicateVideo,
      videoName: this.videoToDuplicate.title
    }));
  }

}

(0, _defineProperty2.default)(DashboardPage, "propTypes", {
  drafts: _dashboardVideos.default.isRequired,
  published: _dashboardVideos.default.isRequired,
  tabs: _propTypes.default.func,
  confirmDeleteVideoPopup: _propTypes.default.func,
  onTabChange: _propTypes.default.func,
  onPlayVideo: _propTypes.default.func,
  dashboardService: _dashboardService.default.isRequired,
  videoService: _videoService.default.isRequired,
  onCreate: _propTypes.default.func.isRequired,
  onEdit: _propTypes.default.func.isRequired,
  onPublish: _propTypes.default.func.isRequired
});
(0, _defineProperty2.default)(DashboardPage, "defaultProps", {
  tabs: _dashboardTabs.default,
  confirmDeleteVideoPopup: _confirmDeleteVideoPopup.default,
  onTabChange: null,
  onPlayVideo: null
});
var _default = DashboardPage;
exports.default = _default;